// This file is AUTOGENERATED, do not edit it manually!!!

export const imageAnnotations = {
    apply: 'Aplicar',
    back: 'Voltar para mensagens',
    cancel: 'Cancelar',
    comment: 'Comentário',
    commented_on_image: 'comentou na imagem',
    comments: 'Comentários',
    delete: 'Excluir',
    delete_comment: 'Excluir este comentário?',
    deleted_image: 'Imagem foi excluída',
    download: 'Baixar imagem',
    edit: 'Editar',
    no_comment: 'Nenhum comentário para exibir',
    write_comment: 'Escreva seu comentário',
};
